import {
  Modal,
  ModalBody,
  ModalHeader,
  Typography,
} from '@one-thd/sui-atomic-components';
import React from 'react';
import { useCommonContext } from '../../../hooks/useContexts';
import {
  IShipmentTrackingDetail,
  TProviders,
} from '../../../models/order-details/track-shipment';
import { getProviderImage } from '../../../utils/order-details/trackingProvider';
import TrackShipmentDetails from './TrackShipmentDetails';

export interface ITrackShipmentModal {
  modalOpen: boolean;
  handleModalClose: () => void;
  shipmentTrackingDetail: IShipmentTrackingDetail | null;
}

export const TrackShipmentModal = ({
  modalOpen,
  handleModalClose,
  shipmentTrackingDetail,
}: ITrackShipmentModal) => {
  const { isMobile } = useCommonContext();
  const mobileSize = isMobile ? 'lg' : 'md';
  const shippingProviderLogo = shipmentTrackingDetail
    ? getProviderImage(shipmentTrackingDetail.providerCode as TProviders)
    : null;

  return (
    <>
      {/* Note: Not able to move the entire Modal in TrackShipmentDetails component by passing 
          props, as it resulted in a error of loader: You may need an additional loader to handle the result of these loaders.
        */}
      <Modal open={modalOpen} onClose={handleModalClose} size={mobileSize}>
        <ModalHeader onClose={handleModalClose}>
          <div className="sui-flex sui-gap-4">
            {shippingProviderLogo}
            <Typography variant="h4" weight="display">
              Package Tracking
            </Typography>
          </div>
        </ModalHeader>
        <hr />
        <ModalBody>
          <TrackShipmentDetails
            shipmentTrackingDetail={shipmentTrackingDetail}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default TrackShipmentModal;
